import { render } from "./RolesTooltip.vue?vue&type=template&id=080b609c"
import script from "./RolesTooltip.vue?vue&type=script&lang=js"
export * from "./RolesTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__